<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" md="4">
        <v-card>
          <v-card-title class="headline" align="center">Iniciar sesión</v-card-title>
          <v-card-text>
            <v-form v-model="valid" lazy-validation>
              <v-text-field
                v-model="username"
                label="Usuario"
                :rules="[rules.required]"
                required
                outlined
              />
              <v-text-field
                v-model="password"
                :type="showPassword ? 'text' : 'password'"
                label="Contraseña"
                :rules="[rules.required]"
                required
                outlined
                append-icon="mdi-eye"
                @click:append="togglePasswordVisibility"
              />
              <v-btn
                :disabled="!valid"
                color="primary"
                @click="submitLogin"
                block
              >
                Iniciar sesión
              </v-btn>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="resetForm">Olvidé mi contraseña</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      valid: false,
      username: '',
      password: '',
      showPassword: false,
      rules: {
        required: value => !!value || 'Este campo es obligatorio.',
      },
    };
  },
  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    submitLogin() {
      // Simulación de inicio de sesión
      if (this.username === 'admin' && this.password === 'admin') {
        this.$router.push('/dashboard');  // Redirigir a Dashboard
      } else {
        alert('Credenciales incorrectas');
      }
    },
    resetForm() {
      alert('Restablecer contraseña');
    }
  },
};
</script>

<style scoped>
.v-card {
  border-radius: 12px;  /* Añadir estilos personalizados */
}
</style>
